/* eslint-disable prefer-const */
import React, { createRef, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button } from '@material-ui/core/'
import apiAdmin from '../../../../../api/admin'
import CardImgs from './CardImgs'
import './index.scss'

const Illustrations = () => {
  const { user } = useSelector(({ session }) => session)
  const uploadBtn = createRef()
  const [imgsUrl, setImgUrl] = useState([])
  const fileArrey = []
  const [loading, setLoading] = useState(false)
  const [skip, setSkip] = useState(0)
  const [fullCount, setFullCount] = useState(0)

  const upload = () => {
    uploadBtn?.current?.setAttribute('multiple', true)
    uploadBtn?.current?.setAttribute('accept', '.jpeg, .png, .svg, .jpg, .gif')
    uploadBtn?.current?.click()
  }

  const getStorys = (limit, skip) => {
    apiAdmin.getStoryImg(limit, skip)
      .then(({ data }) => setImgUrl([...data?.images]))
      .catch(error => console.error(error))
  }

  const getImgCount = () => {
    apiAdmin.getStoryImageCount()
      .then(({ data }) => setFullCount(data?.count))
      .catch(erro => console.error(erro))
  }

  const uploadImgsStorys = img => {
    apiAdmin.uploadImgsStorys(user?.accessKey, [img], 1)
      .then(({ data }) => setImgUrl(prev => [...data?.images, ...prev]))
      .catch(error => console.error(error))
  }

  const deleteStoryById = id => {
    apiAdmin?.deleteStoryById(user?.accessKey, id)
      .then(() => getStorys(20, 0))
      .catch(error => console.error(error))
  }

  const handleChange = e => {
    if (!e?.target?.files?.length) {
      return
    }
    let files = e.target.files
    fileArrey.push(files)
    let reader
    for (var i = 0; i < fileArrey[0].length; i++) {
      reader = new FileReader()
      reader.readAsDataURL(fileArrey[0][i])
      reader.onload = event => {
        uploadImgsStorys(event.target.result)
      }
    }
  }

  const scrollHandler = e => {
    if (e.target.scrollHeight - (e.target.scrollTop + window.innerHeight) < 100) {
      setLoading(true)
    }
  }

  useEffect(() => {
    getStorys(20, skip)
    getImgCount()
  }, [])

  useEffect(() => {
    if (loading && +imgsUrl?.length < +fullCount) {
      if (imgsUrl?.length >= 20) {
        apiAdmin.getStoryImg(20, skip + 20)
          .then(({ data }) => {
            setImgUrl([...imgsUrl, ...data?.images])
            setLoading(false)
          })
          .finally(() => {
            setLoading(false)
            setSkip(prev => prev + 20)
          })
      }
    }
  }, [loading])

  useEffect(() => {
    window?.addEventListener('scroll', scrollHandler, true)
    return function () {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  }, [])

  return (
    <Grid className='wrapperIllustrations'>
      <input onChange={handleChange} className='uploadInputImg' id='selectImage' type='file' ref={uploadBtn} />
      <Button onClick={upload} className='btnAddImgs' variant='contained' color='primary'>
        ADD IMAGE
      </Button>
      <Grid className='boxCardImgs'>
        {imgsUrl?.map(({ src, uuid }) => (
          <CardImgs key={uuid} img={src} id={uuid} deleteStoryById={deleteStoryById} />
        ))}
      </Grid>
    </Grid>
  )
}

export default Illustrations
